
import * as globalActions from './global.actions.js';

export default Object.assign({}, globalActions);



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/